var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkOnlineCourse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25600",
    "data-name": "Group 25600",
    transform: "translate(-336 -1188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    transform: "translate(336 1188)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25597",
    "data-name": "Group 25597",
    transform: "translate(-8 157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24,0H3A3.009,3.009,0,0,0,0,3V24a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,24,0Z",
    transform: "translate(348.5 1035.267)",
    fill: "#750e56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link-24px_3_",
    "data-name": "link-24px (3)",
    transform: "translate(351.181 1037.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13549",
    "data-name": "Path 13549",
    d: "M13.551,18.773l6.711-3.662a1.624,1.624,0,0,1,1.528,0l7.578,4.132a.8.8,0,0,1,.414.7v5.1a.8.8,0,1,1-1.592,0v-4.7l-6.4,3.495a1.581,1.581,0,0,1-1.528,0l-6.711-3.662A.8.8,0,0,1,13.551,18.773Zm1.9,6.265V22.8l4.808,2.627a1.581,1.581,0,0,0,1.528,0L26.6,22.8v2.237a1.6,1.6,0,0,1-.828,1.4l-3.98,2.173a1.581,1.581,0,0,1-1.528,0l-3.98-2.173A1.6,1.6,0,0,1,15.453,25.038Z",
    transform: "translate(-10.5 -11.3)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOnlineCourse);
export default __webpack_public_path__ + "static/media/LINK-ONLINE-COURSE.2852f426463af9784dee944a0dd0817d.svg";
export { ForwardRef as ReactComponent };